<template>
  <div id="form" class="modal with-header white" ref="modal">
     <div class="pl-wrapper">
          <div class="progress" v-if="sending">
              <div class="indeterminate"></div>
          </div>
          </div>
    <div class="header-wrapper">
      <div class="modal-header">
        <div class="title">
          Add New Transcript Request
        </div>
        <ul class="right">
          <li>
            <a class="">
              <i class="material-icons grey-text text-darken-3">minimize</i>
            </a>
          </li>
          <li>
            <a @click="$_toggleFullScreen()">
              <i v-if="!fullScreen" class="material-icons grey-text text-darken-3">
                fullscreen
              </i>
              <i v-else class="material-icons grey-text text-darken-3">
                fullscreen_exit
              </i>              
            </a>
          </li>
          <li>
            <a class="goBack" @click="$_goBack()">
              <i class="material-icons grey-text text-darken-3">close</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <transition name="fade-in">
   
   <div class="modal-content grey lighten-4" v-if="ready">
     <div class="col s12">
      <div class="card white">
       <div class="card-content">
         RequestID: {{viewID}}
       </div>
     </div>
     </div>
    <div class="form-fields">
      <div 
      :class="field.layout"
      v-for="(field, index) in fields" v-bind:key="index">
        <field-types
          @update="$_fieldsData($event)"
          :data-option="field"
        >
        </field-types>
      </div>
    </div>
     <div>
     </div>
   </div>
    </transition>
   <div class="loader-container" v-if="!ready">
        <div 
        class="preloader-wrapper small active">
          <div class="spinner-layer spinner-blue-only">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
   </div>
    <div class="custom-footer">
      <div class="col left">
      <p style="margin:0px;">
        <label>
          <input v-model="notify"  type="checkbox" />
          <span>Send Notification</span>
        </label>
      </p>
      </div>
      <button
        :disabled="sending || !validateForm"
        @click="$_saveRecord()"
        class="btn z-depth-0 right rounded waves-effect">
        Post Request
      </button>
      <button class="btn btn-flat waves-effect transparent right" @click="$_goBack()">
        Cancel
      </button>
      <div class="clear"></div>
    </div>
  </div>
</template>
<script>
import formService from '@/services/formService'
import core from '@/functions'
import fieldTypes from '@/components/records/fieldTypes.component' // records form is original template
import recordFields from '@/components/transcripts/transcripts-incoming-public'
import {mapState} from 'vuex'
import contentService from '@/services/contentService'
export default {
  name:'requestView',
  props:{
    listItems:{
      type:Array
    }
  },
  components:{
    fieldTypes,
  },
  data(){
    let vm = this
    return {
     // fields:recordFields.fields,
      curr_index:0,
      notify: true,
      post: new Object,
      sending:false,
      fullScreen:false,
      ready:false,
      fields:[],
      popFields: {},
      uploads:{
        data:new Array,
        ready:false,
        added:new Array, 
      },
      modal:{
        options:{
          onOpenStart:()=>{
              vm.ready = true 
          },
          onOpenEnd:()=>{
            core.updateFields()
          },
          dismissible:false
        },
        instance:null,
      }
    }
  },
  watch:{
    $route:function(nV){
      nV 
      ? this.modal.instance.close()
      : false
    },
  },
  mounted(){   
    this.$_vModal()
    this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false) 
        let record = this.listItems.find(x => x.id === parseInt(this.$route.params.id))
        this.fields =  recordFields.populateX(record)  
      //  console.log(th)
  },
  beforeDestroy(){
    try{
      this.modal.instance.close()
      this.modal.instance !== null 
      ? this.modal.instance.destroy()
      : false
    }catch(e){
      //console.log(e)
    }
  },
  computed:{
    ...mapState({
      users:state=> state.record.users,
    }),
    fieldsX:{
      get(){
        let record = this.listItems.find(x => x.id === parseInt(this.$route.params.id))
        return recordFields.populateX(record)
      }
    },
    viewID: {
      get () {
         let record = this.listItems.find(x => x.id === parseInt(this.$route.params.id))
        return record.viewId
      }
    },
    toApi: {
      get () {
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : false
        }
        return {
          name: mapValue('name'),
          case_number: mapValue('case_number'),
          requesting_party: mapValue('requesting_party'),
          email:mapValue('email'),
          practitioners: mapValue('practitioners'),
          turn_around_time: mapValue('turn_around_time'),
          hearing_dates: mapValue('hearing_dates') ? mapValue('hearing_dates').map(e => {return {date: e.notes}}) : '',
          transcriptionist: mapValue('transcriptionist') ?  mapValue('transcriptionist').prop : '',
          case_name: mapValue('case_name'),
          judges: mapValue('judges') && mapValue('judges').length ? mapValue('judges').map(e => {return {judge: e.notes}}) : '',
          appearances: mapValue('appearances'),
          heard:mapValue('heard'),
          contact: mapValue('contact'),
          comments: mapValue('comments'),
          status:"not-started",
          viewId: this.viewID
        }
      }
    },
    validateForm:{
      get(){
        return true //this.post.to !== '' & this.post.to !== undefined ? true: false 
      }
    }
  },
  methods:{
    $_vModal(){
      this.modal.instance = core.initModal(this.$refs.modal, this.modal.options)
      setTimeout(() => {
        this.modal.instance.open()
      }, 300);
    },
    $_fieldsData($event){
      let log_structure = (v) => {
        return {
          id:v.id,
          date: new Date,
          message: v.notes
        }
      }
      const record =  this.fields.find(item => item.name === $event.name)
      if($event.name === 'logs') {
          record.values = $event.data.map(item => log_structure(item))
      } else {
        if(record){
          if(record.name === 'from' || record === 'to') record.values = $event.data
          else record.values = $event.data
        } 
      }
     this.post = this.$_postStructure()
    },
    $_toggleFullScreen(){ 
        this.$refs.modal.classList.toggle('fullScreen')  
        let test = () => {
           return  this.$refs.modal.classList.contains('fullScreen')
        } 
       if(test()) {
          this.fullScreen = true
       }
      if(!test()) {
        this.fullScreen = false        
      }
    },
    $_goBack(){
      this.$router.go(-1)
    },
  
    $_sendNotificaiton(data){
      let payload = {
            caseName: this.toApi.case_name,
            case_number: this.toApi.case_number,
            status: this.toApi.status,
            adminUrl: `https://docs.eccourts.org/transcripts/transcript/view/${data.id}?state=edit`,
            for:this.toApi.requesting_party,
            forEmail:this.toApi.email,
            _wpcf7_unit_tag: "0a2c095"
      }
      formService.newRequest(payload, 3521)
      .then(res =>{ 
        window.console.log(res)
        this.$router.go(-1)
        this.$emit('delete', parseInt(this.$route.params.id)) 
      })
    },
    $_postStructure(){
        const mapValue = (prop) =>{
          const record = this.fields.find(item => item.name === prop )
          return record ? record.values : ''
        }
        return {
          name: mapValue('name'),
          case_number: mapValue('case_number'),
          requesting_party: mapValue('requesting_party'),
          transcriptionist: mapValue('transcriptionist'),
          case_name: mapValue('case_name'),
          practitioners: mapValue('practitioners'),
          heard:mapValue('heard'),
          judges: mapValue('judges') ? mapValue('judges').map(e => {return {judge: e.notes}}) : '',
          appearances: mapValue('appearances'),
          logs: mapValue('logs'),
          status: mapValue('status').prop,
          request_form: mapValue('request_form'),
          file_links: mapValue('file_links') && mapValue('file_links').length ? mapValue('file_links').map(e => {return {url: e.notes}}) : '',
         // other_attachments:''
        }
    },
    $_saveRecord (){
      this.sending = true
      const structure = {
        title:this.fields.find(item => item.name === 'case_name' ).values +'-'+this.fields.find(item => item.name === 'case_number' ).values,
        status:'publish',
        fields:{
          ...this.toApi,
        //  other_attachments: this.uploads.added.map(item=> item.file)
        }
      }
     contentService.saveTranscript(structure)
      .then(res=>{
        core.toastMessage('Item Added Successfully')
        
       // this.$store.commit('ADD_RECORD', res.data)

        //this.modal.instance.close()
        this.notify 
        ? this.$_sendNotificaiton(res.data)
        : this.sending = false

 /*        this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)
        this.post = new Object
       
        setTimeout(() => {
          this.ready = true
          this.sending = false
        }, 600); */
    //this.modal.instance.destroy()
    //this.$_vModal()
    //this.fields.forEach(option => option.type !== 'date' ? option.values = "" : false)   
      })
      .catch(() => {
        this.sending = false
      })
    },
  }
}
</script>
<style lang="scss" scoped>
#form{
  &.modal {
     min-height: 85% !important;
    &.fullScreen {
      top: 0 !important;
      width: 100% !important;
      min-height: 100% !important;
    }
  }
  @media screen and (max-width: 680px){
    width:100%;
    top:0% !important;
    height: 100%;
    min-height: 100%;
  }
  &.modal.with-header {
    padding: 0;
    border-radius:6px;
    height: 70%;
  .header-wrapper {
    height:56px;
    position: relative;
    .modal-header {
      position: absolute;
      width:100%;
      padding:20px;
      top: 0;
      line-height:56px;
      height:100%;
      padding:0px 20px;
      border-bottom: .4px solid rgba(0,0,0,0.4);
      .title {
        font-size: 22px;
        display: inline;
      }
      ul {
        display: inline-flex;
        margin:0px;
         li {

           a {
             cursor: pointer;
             margin:0 8px;
              i {
                line-height: 56px;
              }
           }
         }
      }
    }
  }
  .modal-content {
    position: absolute;
    height: calc(100% - 122px);
    max-height: 100%;
    width: 100%;
    top:56px;
    padding:20px;
    overflow-y: auto;
  }
 }
  .custom-footer {
    position: fixed;
    bottom: 0;
    left:0;
    padding: 15px;
    width: 100%;
    background: white;
  }

.loader-container {
  top:50%;
  left:50%;
  width:64px;
  height: 64px;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9;
}
.pl-wrapper {
    position: absolute;
    left: 0;
    top: 42px;
    right: 0;
}
}
</style>
<style lang="scss">

#form {
    .input-field>label {
    //  top: 0;
      left: 10px;
      width: auto;
      
      color:black;
      &.active {
        
        margin-top: 5px;
        width: auto;
        }
      }
    input[type=text]:not(.dropdown-trigger), 
    input[type=text]:not(.browser-default), 
    input[type=number]:not(.browser-default),
    input[type=email]:not(.browser-default),
    input[type=select]:not(.browser-default){
      border: 1px solid rgba(158, 158, 158, 0.35);
      width: calc(100% - 16px);
      margin: 0 0 8px 0;
      padding: 0 8px;
      border-radius:4px;
      background:white;
    }
    textarea.materialize-textarea{
      box-shadow:none !important;
      border-radius:4px;
      border: 1px solid rgba(158, 158, 158, 0.35);
      margin: 0 0 8px 0;
      padding: 16px;
      min-height: 80px;
      background:white;
    }
}
</style>